const overseasServiceContentRouter = {
  route: null,
  name: null,
  title: '出海服务内容',
  type: 'folder',
  icon: 'iconfont el-icon-collection',
  filePath: 'view/overseas_service_content/',
  order: 4,
  inNav: true,
  permission: ['查询服务分类', '查询服务内容'],
  children: [
    {
      title: '服务分类管理',
      type: 'view',
      name: 'overseasServiceCategoryList',
      route: '/overseas-service-category/list',
      filePath: 'view/overseas_service_content/category-list.vue',
      inNav: true,
      icon: 'iconfont el-icon-menu',
      permission: ['查询服务分类'],
    },
    {
      title: '服务数据管理',
      type: 'view',
      name: 'overseasServiceContentList',
      route: '/overseas-service-content/list',
      filePath: 'view/overseas_service_content/content-list.vue',
      inNav: true,
      icon: 'iconfont el-icon-document',
      permission: ['查询服务内容'],
    },
  ],
}

export default overseasServiceContentRouter
